<template>
    <div class="all clearfix">
        <Myleft ref="left"></Myleft>
        <div class="mdCont fl bgff w1070 ml10">
           <div class="grid pb30">
                <div class="screen mt5">
                    <div class="item clearfix">
                        <span class="zu clearfix">
                            <span class="name">平台</span>
                            <span class="drop-down">
                                <button class="btn">{{curMedia}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in mediaList" @click="dropDownChoose(index,1);" :key="index">{{index}}</li>
                                </ul>
                            </span>
                        </span>
                        <span class="zu clearfix">
                            <span class="drop-down">
                                <button class="btn">{{curSort}}<i class="icons fr"></i></button>
                                <ul class="option">
                                    <li v-for="(item,index) in sortList" @click="dropDownChoose(index,2);" :key="index">{{index}}</li>
                                </ul>
                            </span>
                        </span>
                       
                        <span class="zu clearfix">
                            <span class="name">地区</span>
                            <city @cityCallback="citySelect" :isHasWorld='true'></city>
                        </span>
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down">
                                <vue-datepicker-local ref="timeSelect" v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons clearable @clear="selectedDate" @confirm="selectedDate" placeholder="请选择时间"/>
                            </span>
                        </span>
                        <div class="zu">
                            <button class="search-btn fr" @click="KeyUpEsc">搜索</button> 
                            <div class="hidden"><input type="text" placeholder="请输入关键词" class="input-text fl" v-model="keywords" @keyup.enter="KeyUpEsc"></div>
                        </div>
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body mh270">
                        <div class="no-data" v-if="nodata.hotList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <ul class="article-list">
                            <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                                <!-- <a class="img fl" :href="item.news_url" target="_blank"><img :src="item.picurl" :onerror="defaultImg"/></a> -->
                                <router-link v-if="item.isShowImg" class="img fl" :to="{path:'newsDetail',query:{id:item.id,newsType:mediaList[curMedia]}}" target="_blank"><img :src="item.isLoadStart?item.curImg:imgChose(item,index)" :onerror="defaultImg"/></router-link>
                                <div class="hidden">
                                    <div class="clearfix " :class="{'mt15':item.isShowImg}">
                                        <!-- <div class="grid-info fr mt5 ml5" v-if="index==0">
                                            <i class="icons icon-ask"></i> 
                                            <p class="grid-tip r">热度值：根据转载传播计算的热度值</p>
                                        </div> -->
                                        <span class="fr mt5 cre6" v-if="item.exponent!=undefined"><i class="icons icon-fire"></i>{{item.exponent}}</span>
                                        <h2 class="newsTit">
                                            <router-link class="cr00 fl" :class="curMedia!='微博'?'ovhidden':'ovhidden2'" :to="{path:'newsDetail',query:{id:item.id,newsType:mediaList[curMedia]}}" target="_blank">{{item.news_title}}</router-link>
                                            <a class="cr27 fs12 fl mt5" :href="item.news_url"><i class="icons icon-link mt0"></i> 原文链接</a>
                                        </h2>
                                    </div>
                                    <p class="ovhidden2 mt5">{{item.news_digest}}</p>
                                    <p class="ziduan mt10 cr77">
                                        <span class="tag tag-blue fr">{{item.news_tags}}</span>　
                                        <span v-if="item.source_name===''"><i class="icons sm-icon" :class="showNewType(item.news_type,1)"></i>{{showNewType(item.news_type,2)}} ·  </span>
                                        <span v-else><i class="icons sm-icon" :class="showNewType(item.news_type,1)"></i>{{item.source_name}} ·  </span>
                                        <span>{{timeFilter(item.publish_time)}}</span>
                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                        <div class="mt20 ac" v-if="isShowMore">
                            <a class="btnMmore color-8a8a99" href="javascript:void(0);" @click="showMore">加载更多</a>
                        </div>
                        <div class="mt20 ac" v-if="isShowEnd">
                            <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="mrCont w310 bgff fr">
            <div class="grid">
                <div class="grid-header clearfix">
                    <h2 class="title"><img src="static/images/jzTit.png"/></h2>
                </div> 
                <div class="grid-body ">
                    <ul class="jzNews">
                        <li class="mb20" v-for="(item,index) in jzNewsList" :key="index">
                            <div class="imgText clearfix">
                                <router-link class="img fl cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank"><img :src="item.picurl" :onerror="defaultImg"/></router-link> 
                                <div class="hidden">
                                    <h4 class="ovhidden3 mt5 fs14">
                                        <router-link class="cr00 cp" :to="{path:'pointDetail',query:{id:item.id}}" target="_blank">{{item.news_title}}</router-link>
                                    </h4>
                                </div>
                            </div>
                        </li>
                    </ul> 
                    <ul class="jzNews event mb20">
                        <li v-for="(item,index) in jzNewsList" :key="index">
                            <router-link class="img" :to="{path:'eventTag',query:{id:item.id,type:item.name}}">
                                <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                                <span class="name ac db">{{item.name}}</span>
                            </router-link>
                        </li>
                    </ul>
                    <div class="no-data pt30" v-if="nodata.jzNewsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                </div>
            </div>
        </div> -->
    </div>
</template>
<script>
import Myleft from '../../components/left'
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {Myleft,VueDatepickerLocal,city},
    data() {
        return {
            curIcon:'web-icon',
            icons:{
                '微信':'wx-icon',
                '网页':'web-icon',
                '微博':'wb-icon',
                '头条':'toutiao-icon',
                '抖音':'dy-icon',
            },
            jzNewsList:[],
            defaultImg:'this.src="static/images/default.png"',
            curMedia:'全部',//当前媒体
            mediaList:{'全部':4,'网页':1,'微信':2,'微博':3,'头条':5,'抖音':6},//媒体下拉列表
            curSort:'热度值降序', //当前排序
            sortList:{'热度值降序':"hot_down",'时间降序':"time_down"},//排序下拉列表
            tags:'全部',
            isHasWorld:true, //是否包含国际选项
            hotList:[],
            pageCur:1,
            pageNum:6,
            dataCount:0,
            timeRange: [],
            nowTime: new Date(),  //时间选择
            startTime:null,
            endTime:null,
            province:'',//省份
            city:'',//城市
            county:'',//区县
            keywords:'', //搜索关键词
            lastTime:'',
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                jzNewsList:false,
                hotList:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            that.initialTime();
            // that.dataAjax();
            that.hotListAjax();
            that.$utils.screenHeight();
        }) 
    },
    watch: {
		$route(){
			let that = this;
            that.tags = that.$route.query.type;
            that.$refs.left.curType = that.tags;
            that.keywords = '';
            that.clearListData();
		},
	},
    methods: {
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,0);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2], n2[0], n2[1], n2[2])
            min = new Date(o[0], o[1]-1, o[2],0, 0, 0)
            this.timeRange = [max,max];//2020/12/17 原：this.timeRange = [min],max];
            //进页面获取时间数据
            this.startTime = this.$utils.dateConversion(min,1);
            this.endTime = this.$utils.dateConversion(max,1);
        },
        dropDownChoose(index,type){
            let that = this;
            if(type===1){
                that.curMedia = index;
            }else{
                that.curSort = index;
            }
            that.curIcon = that.icons[index];
            that.clearListData();
        },
        showNewType(type,num){
            let that = this;
            for (let key in that.mediaList) {
                if(that.mediaList[key] == type){
                    if(num ==1){
                        return that.icons[key];
                    }else{
                        return key;
                    }
                }
            }
        },
        dataAjax(){
            let that = this;
            let datas={
                column:'较真'
            };
            //that.$api.get('viewpoint/index/list',datas,r=>{
            that.$api.get('hotnews/index/tag-list-right',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.jzNewsList = r.data;
                    if(r.data.list.length<=0){
                        that.nodata.jzNewsList = true;
                    }else{
                        that.nodata.jzNewsList = false;
                    }
                });
            });
        },
        // 地区筛选
        citySelect (name) {
            let province = name[0];
            let city = name[1];
            let county = name[4];
            let that = this;
            
            if(province === '国际'){
                city = ''
            }
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.county = (county === '全市'|| county === '选择区县')?'':county;
            that.city = (city === '全市'||city === '全省'|| city === '选择城市')?'':city;
            that.clearListData();
        },
        hotListAjax(){
            let that = this,tags='';
            tags = (that.tags == '全部')?'':that.tags;
            let datas={
                search:that.keywords,
                news_type:that.mediaList[that.curMedia],
                order_type:that.sortList[that.curSort],
                tag:tags,
                start_time:that.startTime,
                end_time:that.endTime,
                province:that.province,
                city:that.city,
                county:that.county,
                perpage:that.pageNum,
                page:that.pageCur,
                last_time:that.lastTime,
            };
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('news/index/index',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        that.lastTime = '';
                        if(that.pageCur==1){
                            that.nodata.hotList = true;
                            return
                        }
                        that.isShowMore = false;
                        that.isShowEnd = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                        that.isShowMore = true;
                    }
                    let data = r.data.list;
                    data.forEach(ele => {
                        ele.isLoadStart = false;
                        ele.isShowImg = true;
                    });
                    let len = data.length;
                    that.lastTime = data[len-1].publish_time;
                    that.hotList = that.hotList.concat(data);
                });
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            that.hotListAjax();
        },
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        choseType(type){
            let that = this;
            that.typeName = type;
            that.clearListData();
        },
       
        disabledDate (time) {
            //return time < this.min || time > this.max
            return time > this.nowTime
        },
        selectedDate (date) {
            let that = this;
            if(date == undefined){
                that.startTime = '';
                that.endTime = '';  
            }else{
                let startTime = that.$utils.dateConversion(that.timeRange[0],0);
                that.startTime = startTime + " 00:00:00";
                let endTime = that.$utils.dateConversion(that.timeRange[1],0);
                that.endTime = endTime + " 23:59:59";
            }
            that.clearListData();
        },
        //搜索内容
        KeyUpEsc(){
            let that = this;
            that.clearListData();
        },
        timeFilter(t){
            var newT = '';
            if(t!=null){
                let tmp = t.split(':');
                newT = tmp[0]+':'+tmp[1];
                return newT;
            }
        },
        loadImg(ele,i,item,len){
            let that= this;
            let img = new Image()
            img.src = ele
            img.onload = function () {
                if(img.width>200 && ((img.width/img.height)<3)){
                    item.curImg = ele;
                    item.isLoadStart = true;
                    //console.log(img.width/img.height)
                    return
                }
                if(i>=(len-1)){
                    item.curImg = '';
                    item.isLoadStart = true;
                    item.isShowImg = false;
                    return 
                }
                that.loadImg(item.news_imgs[i+1],(i+1),item,len);
            }
        },
        imgChose(item,index){
            let that= this,len = item.news_imgs.length;
            if(len==1 && item.news_imgs[0]==''){
                item.isLoadStart = true;
                item.curImg='';
                item.isShowImg = false;
                return;
            }
           that.loadImg(item.news_imgs[0],0,item,len); 
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/news/news.vue